// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  defaultLang: 'en',
  aws: {
    appsync: {
      default: {
        url: 'https://yyhpek4qzrg25gh56dg4w3pnou.appsync-api.eu-west-1.amazonaws.com/graphql',
        region: 'eu-west-1',
        desc: 'Dev',
      },
      list: [
        {
          url: 'https://yyhpek4qzrg25gh56dg4w3pnou.appsync-api.eu-west-1.amazonaws.com/graphql',
          region: 'eu-west-1',
          desc: 'Dev',
        },
        {
          url: 'https://rk4j45mv3bhn7f5xu6fl4pjnb4.appsync-api.eu-west-1.amazonaws.com/graphql',
          region: 'eu-west-1',
          desc: 'Test',
        },
        {
          url: 'https://3m5nt7visfcntat4jlinc4ef2y.appsync-api.eu-west-1.amazonaws.com/graphql',
          region: 'eu-west-1',
          desc: 'Pre-prod',
        },
        {
          url: 'https://eg264b6fvfgb3jyc7gvvpqab7m.appsync-api.eu-west-1.amazonaws.com/graphql',
          region: 'eu-west-1',
          desc: 'Prod',
        },
      ],
    },
  },
  firebase: {
    apiKey: 'AIzaSyCTFwAoDwQaUWFhMEHeqUDw-rvu65vuX_0',
    appId: '1:107808526586:web:74a5f206daaf339b8eb943',
    authDomain: 'azzurroagent-qfmyjb.firebaseapp.com',
    databaseURL: 'https://azzurroagent-qfmyjb.firebaseio.com',
    locationId: 'us-central',
    messagingSenderId: '107808526586',
    projectId: 'azzurroagent-qfmyjb',
    storageBucket: 'azzurroagent-qfmyjb.appspot.com',
    measurementId: 'G-CVVP44MX0N',
  },
  production: true,
  emulator: false,
  timezone: {
    url: 'https://vip.timezonedb.com/v2.1/get-time-zone',
    apiKey: 'Y0UG9PIL0B2L',
  },
  weather: {
    url: 'https://api.openweathermap.org/data/2.5/weather',
    apiKeys: [
      '94085170154432239d3da7cc6dfa7791',
    ],
  },
  FIRESTORE_EMULATOR_HOST: 'localhost',
  FIRESTORE_EMULATOR_PORT: 8080,
  version: '1.0.196',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
